import $ from "jquery";

const $body = $('body');



const filterMenu = () => {

    const $trigger_filter = $('[data-trigger-filter]');
    const $filter__wrapper = $('.filter__wrapper');
    const $filter__overlay = $('.filter__overlay');
    const $filter__close = $('.filter__close');
    const $apply__filter = $('[data-trigger-apply-filter]');
    const $header__bottom = $('.header__bottom');

    $trigger_filter.on('click', function () {
        if ($(this).hasClass('open')) {
            $(this).removeClass('open');
            $filter__wrapper.removeClass('open');
            $filter__overlay.removeClass('open');
            // setTimeout(function () {
            //     $header__bottom.removeClass('hide');
            // }, 100);
            $body.removeClass('modal__open');
        } else {
            $(this).addClass('open');
            $filter__wrapper.addClass('open');
            $filter__overlay.addClass('open');
            $body.addClass('modal__open');
            // $header__bottom.addClass('hide');
        }
    });

    $filter__close.on('click', function () {
        $trigger_filter.removeClass('open');
        $filter__wrapper.removeClass('open');
        $filter__overlay.removeClass('open');
        $body.removeClass('modal__open');
        // setTimeout(function () {
        //     $header__bottom.removeClass('hide');
        // }, 100);
    });

    $apply__filter.on('click', function () {
        $trigger_filter.removeClass('open');
        $filter__wrapper.removeClass('open');
        $filter__overlay.removeClass('open');
        $body.removeClass('modal__open');
        // setTimeout(function () {
        //     $header__bottom.removeClass('hide');
        // }, 100);
    });


    const collapseTriggerList = document.querySelectorAll('.collapse')

    const collapseList = [...collapseTriggerList].map(collapseTriggerEl =>
        collapseTriggerEl.addEventListener('shown.bs.collapse', event => {

            let prevElement = event.target.previousElementSibling
            const block = document.querySelector('.filter__block_wrap');

            block.scrollTo({top: prevElement.offsetTop - 40, behavior: 'smooth'});
        })
    );

    $apply__filter.on('click', function () {
        $trigger_filter.removeClass('open');
        $filter__wrapper.removeClass('open');
        $filter__overlay.removeClass('open');
        $body.removeClass('modal__open');
        // setTimeout(function () {
        //     $header__bottom.removeClass('hide');
        // }, 100);
    });

}



const resetFilter = () => {

    const $reset_filter = $('[data-reset-filter]');

    $reset_filter.on('click', function (e) {

        var currURL = window.location.href;
        let url = new URL(currURL);
        let params = new URLSearchParams(url.search);

        params.delete('price');
        params.delete('material');
        params.delete('attribute');
        params.delete('stock');

        $body.addClass('loading');

        delay(function () {
            window.history.replaceState({}, '', `${location.pathname}?${params}`);
            location.reload();
        }, 150)

    });

}


filterMenu()

resetFilter()
